import React from 'react';

const HorizontalAmenities = () => {
    return (
        <div className="horizontal-panel amenities-panel">
            <div className="amenities-panel-content">
                <div className="amenities-text-content welcome-section">
                    <h1 className="welcome-title animate-fade-in">Welcome to Hollywood Royale Garden</h1>
                    <p className="welcome-text animate-fade-in">
                        Hollywood Royale Garden, an assisted living community, is designed to create opportunities for residents to feel at home, surrounded by familiar spaces and staff who will support personal needs. We offer both private and shared rooms including lovely patios and balconies.
                    </p>
                </div>
            </div>

            {/* Animated GIF (turbine) */}
            {/* <img src="/seniorcitigen.gif" alt="Turbine animation" className="turbine-gif" loading="lazy" decoding="async" /> */}
        </div>
    );
};

export default HorizontalAmenities;
